import { Controller } from "stimulus";

export default class extends Controller {
  static values = {
    rowUrlTarget: String
  };

  static targets = ['tableCellCheckbox', 'tableRow']

  connect() {
    this._boundHighlightExistingCheckboxes = this._highlightExistingCheckedRows.bind(this);
    this._boundHandleRowClick = this._handleRowClick.bind(this);

    document.addEventListener(
      "promote:highlight-table-checkboxes",
      this._boundHighlightExistingCheckboxes
    );
    document.addEventListener(
      "promote:data-table:selection",
      this._boundHighlightExistingCheckboxes
    );

    this._boundHighlightExistingCheckboxes();
    this.element.addEventListener('click', this._boundHandleRowClick);
  }

  disconnect() {
    document.removeEventListener(
      "promote:highlight-table-checkboxes",
      this._boundHighlightExistingCheckboxes
    );
    this.element.removeEventListener('click', this._boundHandleRowClick);
  }

  highlightRow(event) {
    const target = event.target;

    this._highlightRow(target);
  }

  _highlightRow(target) {
    if (target.checked) {
      target.closest('.js-table-body-row').classList.add('selected');
    } else {
      target.closest('.js-table-body-row').classList.remove('selected');
    }
  }

  highlightAllRows(event) {
    if (event.target.checked) {
      this.tableRowTargets.forEach((row) => {
        row.classList.add('selected');
      });
    } else {
      this.tableRowTargets.forEach((row) => {
        row.classList.remove('selected');
      });
    }
  }

  _highlightExistingCheckedRows() {
    this.tableCellCheckboxTargets.forEach((checkbox) => {
      this._highlightRow(checkbox)
    });
  }

  _handleRowClick(event) {
    const target = event.target;

    const row = target.closest('[data-components--table-target="tableRow"]');
    if (!row) return;

    const link = row.querySelector('[data-components--table-target="tableRowLink"]');
    if (!link) return;

    // Don't trigger row click if user is selecting text
    const selectedText = window.getSelection().toString();
    if (selectedText.length > 0) return;

    // Don't trigger row click if clicking on interactive elements
    const isInteractive = target.closest(
      'button, a:not([class*="pointer-events-none"]), input, [role="button"]'
    );

    if (!isInteractive) {
      // Ctrl+click or Cmd+click opens in new tab
      if (event.ctrlKey || event.metaKey || this.rowUrlTargetValue == '_blank') {
        window.open(link.href, '_blank');
      } else {
        link.click();
      }
    }
  }
}
